import { formatDisplayNumber } from "utils/functions/number";
import { MetricCellStyled } from "./styled";

const MetricCell = ({ label, value, unit }) => {
  return (
    <MetricCellStyled>
      <span className="metric_label">{label} </span>
      <span className="metric_value">{formatDisplayNumber(value)}</span>
      <span className="metric_label"> {unit}</span>
    </MetricCellStyled>
  );
};

export default MetricCell;
